import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiService } from '@shared/services';

@Injectable({ providedIn: 'root' })
export class HcmJobPostService extends ApiService<string> {

  constructor(http: HttpClient) {
    super(http);
    this.url = 'hcm-job-post';
  }
}
